import styled from 'styled-components';

export const IteroTCContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const IteroTCText = styled.div`
  width: 80%;
`;

export const ButtonWrapper = styled.div`
  width: 20%;
  display: flex;
  justify-content: flex-end;
`;

export const Separator = styled.div`
  margin: 20px 0;
  border-bottom: 1px solid #00000014;
`;
